/* esm.sh - get-nonce@1.0.1 */
var e,r=function(n){e=n},t=function(){if(e)return e;if(typeof __webpack_nonce__<"u")return __webpack_nonce__};export{t as getNonce,r as setNonce};
//# sourceMappingURL=get-nonce.mjs.map